export function uniqueId(prefix) {
  return prefix + "-" + Math.floor(Date.now() * Math.random());
}
//# sourceMappingURL=unique-id.js.map